import { gql } from '@apollo/client'
import { VOOH_MEDIA_FIELDS } from '../fragments'

export const GET_VOOH_MEDIA_TEMPLATES = gql`
  ${VOOH_MEDIA_FIELDS}
  query VoohMediaTemplates($mediaFormat: VoohMediaFormatEnum!) {
    voohMediaTemplates(mediaFormat: $mediaFormat) {
      nodes {
        id
        media {
          ...VoohMediumFields
        }
        name
      }
    }
  }
`
